import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmsConfig, I18nModule, provideConfig } from '@spartacus/core';
import { CustomTrustedShopsWidgetModule } from 'src/app/custom/cms-components/trustedshops/custom-truestedshops-widget/custom-trustedshops-widget.module';
import { CustomProductReviewsTrustedshopsComponent } from './custom-product-reviews-trustedshops.component';

@NgModule({
  declarations: [CustomProductReviewsTrustedshopsComponent],
  imports: [CommonModule, I18nModule, CustomTrustedShopsWidgetModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        ProductReviewsTrustedShopsComponent: {
          component: CustomProductReviewsTrustedshopsComponent,
        },
      },
    }),
  ],
})
export class CustomProductReviewsTrustedshopsModule {}
